import { CloseIcon } from '../Icon/CloseIcon';
import { DraftIcon } from '../Icon/DraftIcon';
import styles from './FileList.module.css';

interface FileListFile {
  id: string;
  filename: string;
}

interface Props {
  files: FileListFile[];
  onDelete: (fileId: string) => void;
}

type ItemProps = Pick<Props, 'onDelete'> & {
  file: FileListFile;
};

function FileListItem({ file, onDelete }: ItemProps) {
  const parts = file.filename.split('.');
  const extension = parts.length <= 1 ? '' : parts[parts.length - 1];

  return (
    <li>
      <div className={styles.file}>
        <DraftIcon className={styles.doctype} />

        <div className={styles.meta}>
          <h6 className={styles.filename}>{file.filename}</h6>
          <p className={styles.ext}>{extension.toUpperCase()}</p>
        </div>

        <button type="button" className={styles.delete} onClick={() => onDelete(file.id)}>
          <CloseIcon />
        </button>
      </div>
    </li>
  );
}

export function FileList({ files, onDelete }: Props) {
  return (
    <ul className={styles.fileList}>
      {files.map(file => (
        <FileListItem key={file.id} file={file} onDelete={onDelete} />
      ))}
    </ul>
  );
}
